<template>
  <div>
    <b-card
      tag="article"
      no-body
    >
      <b-card-body>
        <b-media no-body>
          <b-media-aside
            vertical-align="center"
            class="mr-50"
          >
            <b-avatar
              size="64"
              :src="apiUrl + tutor.photo"
            />
          </b-media-aside>
          <b-media-body>
            <b-row>
              <b-col>
                <span class="text-body">{{ tutor.fullName }}</span>
                <span class="text-muted ml-75 mr-50">|</span>
                <small class="text-muted">{{ tutor.school }}</small>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div
                  class="blog-title-truncate text-body-heading"
                >
                  {{ tutor.title }}
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <ul class="unstyled-list list-inline">
                  <li
                    v-for="star in tutorRating"
                    :key="star"
                    class="ratings-list-item"
                    :class="{ 'ml-25': star - 1 }"
                  >
                    <feather-icon
                      icon="StarIcon"
                      size="16"
                      :class="[
                        { 'fill-current': true },
                        true ? 'text-warning' : 'text-muted',
                      ]"
                    />
                  </li>
                  <li
                    v-for="star in (5 - tutorRating)"
                    :key="star"
                    class="ratings-list-item"
                    :class="{ 'ml-25': star }"
                  >
                    <feather-icon
                      icon="StarIcon"
                      size="16"
                      :class="[
                        true ? 'text-warning' : 'text-muted',
                      ]"
                    />
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-media-body>
        </b-media>
        <div class="my-1 py-25">
          <span> Skills : </span>
          <b-link
            v-for="(tag,index) in tutor.tags"
            :key="index"
          >
            <b-badge
              pill
              class="mr-75"
              :variant="tagsColor()"
            >
              {{ tag.name }}
            </b-badge>
          </b-link>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BFormInput, BCardText, BCardTitle, BMedia, BAvatar, BMediaAside, BMediaBody, BImg, BCardBody, BLink, BBadge, BFormGroup, BInputGroup, BInputGroupAppend, BPagination,
  BButton,
} from 'bootstrap-vue'
import { kFormatter } from '@core/utils/filter'
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardBody,
    BCardTitle,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BPagination,
    BButton,
    ContentWithSidebar,
  },
  props: ['tutor'],
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      tutorRating: null,
    }
  },
  created() {
    this.$http.post('/ratings', { tutor: this.tutor._id }).then(res => {
      console.log(res.data)
      if (res.data.ratings.length > 0) {
        this.tutorRating = res.data.ratings[0].rating
      } else {
        this.tutorRating = 0
      }
    })
  },
  methods: {
    kFormatter,
    tagsColor() {
      const colors = ['light-info', 'light-danger', 'light-primary', 'light-secondary', 'light-success']
      const random = Math.floor(Math.random() * colors.length)
      return 'light-info'
    },
    selectTag(tag) {
      if (tag == this.selectedTag) return this.selectedTag = ''
      return this.selectedTag = tag
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
</style>
